const carouselContextKey = Symbol("carouselContextKey");

export { carouselContextKey };
//# sourceMappingURL=constants.mjs.map
